import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import { copilotUpsellStore } from '../store/copilotUpsellStore';

export function getCopilotUpsellEligibility(mailboxInfo: MailboxInfo): boolean {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const store = copilotUpsellStore();
    return (
        (store.eligibilityByAccount.get(accountKey) ?? false) ||
        store.pendingEntitlementByAccount.has(accountKey)
    );
}

export function getIsCopilotUpsellEntitlementPending(mailboxInfo: MailboxInfo): boolean {
    return copilotUpsellStore().pendingEntitlementByAccount.has(
        getAccountKeyForMailboxInfo(mailboxInfo)
    );
}
